import type { ComplianceFiling, TaskAmountExtract } from '../types';

export type FinalizeRowState = 'filed' | 'ready' | 'needs-reconcile';

export function finalizeRowState(
  filing: ComplianceFiling,
  extract: TaskAmountExtract | undefined,
): FinalizeRowState {
  if (filing.filedAt) return 'filed';
  const total = extract?.filed?.totalDue ?? extract?.amounts?.totalDue;
  return typeof total === 'number' ? 'ready' : 'needs-reconcile';
}
